import type { MouseEventHandler, MutableRefObject } from "react";
import React from "react";
import className from "~/kernel/styling/className";

type Props = {
  children: React.ReactNode;
};

export type ListItemProps = {
  children: React.ReactNode;
  compact?: boolean;
  ref?: MutableRefObject<HTMLLIElement | null>;
  transparent?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /**
   * Set to true to remove leading & trailing space.
   **/
  trim?: boolean;
};

export const ListItem = React.forwardRef<HTMLLIElement, ListItemProps>(
  function ListItem(
    { onClick, trim, transparent, children, compact = false }: ListItemProps,
    ref,
  ) {
    const borderClass = "border-b border-slate-200 last:border-b-0";
    const containerClass = className({
      "pt-5 pb-5": !compact,
      "pt-3 pb-3": compact,
      "first:pt-0 last:pb-0": trim,
      "opacity-0": transparent,
    });

    if (onClick) {
      return (
        <li ref={ref} className={borderClass}>
          <button
            onClick={onClick}
            type="button"
            className={className(
              containerClass,
              "hover:bg-slate-100 w-full text-left",
            )}
          >
            {children}
          </button>
        </li>
      );
    }

    return (
      <li ref={ref} className={className(borderClass, containerClass)}>
        {children}
      </li>
    );
  },
);

export default function List({ children }: Props) {
  return <ul>{children}</ul>;
}

List.Item = ListItem;
